import { createFileRoute } from '@tanstack/react-router';
import { useFlagsStatus } from '@unleash/proxy-client-react';
import { useTranslation } from 'react-i18next';

import { Slice } from '@furality/furality-purpose';
import CartSummary from '@/components/_cart/CartSummary.tsx';
import AddVoucher from '@/components/_register/steps/AddVoucher.tsx';
import LinkButton from '@/components/LinkButton.tsx';
import { RegisterLayout } from '@/components/layouts/index.tsx';
import PageLoading from '@/components/loading/PageLoading.tsx';
import useFlag from '@/lib/hooks/useFlag.ts';
import useCart from '@/lib/useCart.tsx';

// biome-ignore lint/style/useComponentExportOnlyModules: tanstack route
const BuyVoucher = () => {
  const featuresReady = useFlagsStatus().flagsReady;
  const regIsOpen = useFlag('registration');
  const { t } = useTranslation(['common', 'register', 'buyvoucher']);
  const { cart, products } = useCart();

  if (!featuresReady) {
    return <PageLoading />;
  }

  if (!regIsOpen) {
    return (
      <Slice size="lg" className="text-center">
        {t('shared.registration_closed')}
      </Slice>
    );
  }

  const disabled = cart.data?.total === 0;

  return (
    <Slice size="lg">
      <div className="text-center d-flex flex-column align-items-center">
        <h1>{t('shared.navigation.buyvoucher')}</h1>
        <div className="mb-4">{t('register:addons.voucher.content')}</div>
        {products.isFetched && (
          <AddVoucher label="buyvoucher:add_to_cart.button" className="mb-5" />
        )}
        <CartSummary
          items={cart.data?.items}
          isLoading={cart.isPending}
          total={cart.data?.total}
          allowRemoval
          className="col-12 col-lg-6"
        />
        <div>
          <LinkButton to="/profile" variant="secondary">
            {t('shared.return_to_profile')}
          </LinkButton>
          <LinkButton to="/checkout" disabled={disabled}>
            {t('shared.continue')}
          </LinkButton>
        </div>
      </div>
    </Slice>
  );
};

export const Route = createFileRoute('/buy-voucher')({
  component: () => (
    <RegisterLayout title="shared.navigation.buyvoucher">
      <BuyVoucher />
    </RegisterLayout>
  ),
});
